var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAddress = function SvgAddress(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 21,
    fill: "#fff"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.14 0C5.246 0 3.43.738 2.091 2.05A6.93 6.93 0 0 0 0 7c0 7 7.14 14 7.14 14s7.14-7 7.14-14a6.93 6.93 0 0 0-2.091-4.95A7.22 7.22 0 0 0 7.14 0m0 9.763a2.85 2.85 0 0 1-1.997-.811 2.74 2.74 0 0 1-.826-1.958c0-.734.298-1.438.829-1.957a2.86 2.86 0 0 1 1.997-.809c.75.001 1.467.294 1.996.814A2.74 2.74 0 0 1 9.963 7a2.74 2.74 0 0 1-.829 1.954c-.53.518-1.246.81-1.994.81z"
  })));
};
export default SvgAddress;